<div class="contentFullVerticalHeight halfVerticalHeight">
    <div class="container">
        <div class="w-100" [innerHTML]='"copy.html.FIBHealth.FIBHealthCopy"|copy|async'></div>
    </div>
</div>